module.exports = __webpack_public_path__ + "static/media/down_arrow.1684aa24.svg";